import { render, staticRenderFns } from "./NewDrawnCounter.vue?vue&type=template&id=56bbd52a&scoped=true"
import script from "./NewDrawnCounter.vue?vue&type=script&lang=js"
export * from "./NewDrawnCounter.vue?vue&type=script&lang=js"
import style0 from "./NewDrawnCounter.vue?vue&type=style&index=0&id=56bbd52a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bbd52a",
  null
  
)

export default component.exports